import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import { StepProps } from '../../types';

const Container = styled.div`
  ${tw`flex flex-col h-full`}
`;

const SectionLabel = styled.div`
  ${tw`text-xs font-semibold text-text-secondary uppercase tracking-wider mb-3`}
`;

const Title = styled.h2`
  ${tw`text-xl font-semibold text-text-primary mb-2`}
`;

const Subtitle = styled.p`
  ${tw`text-sm text-text-secondary mb-6`}
`;

const InputGroup = styled.div`
  ${tw`mb-6`}
`;

const Label = styled.label`
  ${tw`block text-sm font-medium text-text-secondary mb-2`}
`;

const Input = styled.input`
  ${tw`w-full p-3 border border-border-default rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent`}
`;

const ContinueButton = styled.button<{ disabled: boolean }>`
  ${tw`w-full py-4 font-semibold rounded-card mt-auto`}
  ${props =>
    props.disabled
      ? tw`bg-bg-secondary text-text-tertiary cursor-not-allowed`
      : tw`bg-black text-white hover:bg-black-hover`}
`;

const IncidentDateTimeStep: React.FC<StepProps> = ({ formData, updateFormData, onNext }) => {
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const dateValue = e.target.value;
    if (dateValue) {
      updateFormData({ incidentOccurredAt: new Date(dateValue) });
    } else {
      updateFormData({ incidentOccurredAt: undefined });
    }
  };

  const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateFormData({ incidentTime: e.target.value });
  };

  const formatDateForInput = (date?: Date): string => {
    if (!date) return '';
    return date.toISOString().split('T')[0];
  };

  const canContinue = !!formData.incidentOccurredAt;

  return (
    <Container>
      <SectionLabel>DAMAGE DETAILS</SectionLabel>
      <Title>When did the incident occur?</Title>
      <Subtitle>
        If you don't know the date the incident occurred, select the date you discovered the damage.
      </Subtitle>

      <InputGroup>
        <Label>Date *</Label>
        <Input
          type="date"
          value={formatDateForInput(formData.incidentOccurredAt)}
          onChange={handleDateChange}
          max={new Date().toISOString().split('T')[0]}
        />
      </InputGroup>

      <InputGroup>
        <Label>Time (optional)</Label>
        <Input type="time" value={formData.incidentTime || ''} onChange={handleTimeChange} />
      </InputGroup>

      <ContinueButton disabled={!canContinue} onClick={onNext}>
        Continue
      </ContinueButton>
    </Container>
  );
};

export default IncidentDateTimeStep;
